import {createDraftSafeSelector} from '@reduxjs/toolkit';

import dateUtils from '../../utils/dateUtils';

const selectMessageState = (state) => state.message;

export const selectAllMessages = createDraftSafeSelector(selectMessageState, (state) => state.messages);

export const selectMessageById = (messageId) =>
    createDraftSafeSelector(selectMessageState, (state) =>
        state.messages.find((message) => message?.messageId === messageId)
    );

export const selectUnreadMessageCount = createDraftSafeSelector(
    selectMessageState,
    (state) => state.unreadMessageCount
);

export const selectUndeletedMessages = createDraftSafeSelector(
    selectMessageState,
    (state) => state.messages?.filter((message) => !message.isDeleted) || []
);

export const selectSortedUndeletedMessages = createDraftSafeSelector(
    selectUndeletedMessages,
    (messages) =>
        messages?.sort(
            (a, b) => dateUtils.parseDateString(b.sentMessageTime) - dateUtils.parseDateString(a.sentMessageTime)
        ) || []
);

export const selectLastReceivedMessageId = createDraftSafeSelector(
    selectMessageState,
    (state) => state.lastReceivedMessageId
);
